
export const notificationSections = [
  {
    id: "channels",
    title: "Notification Channels",
    description: "Choose how you want to receive notifications",
    items: [
      {
        id: "email-notifications",
        field: "email_notifications",
        label: "Email Notifications",
        description: "Receive notifications via email"
      },
      {
        id: "sms-notifications",
        field: "sms_notifications",
        label: "SMS Notifications",
        description: "Receive notifications via SMS text message"
      },
      {
        id: "webpush-notifications",
        field: "web_push_notifications",
        label: "Web Push Notifications",
        description: "Receive notifications via browser push"
      },
      {
        id: "app-notifications",
        field: "app_notifications",
        label: "Mobile App Notifications",
        description: "Receive notifications in the mobile app"
      }
    ]
  },
  {
    id: "types",
    title: "Notification Types",
    description: "Select which types of notifications you want to receive",
    items: [
      {
        id: "account-notifications",
        field: "account_notifications",
        label: "Account Updates",
        description: "Be notified about important account changes and security updates"
      },
      {
        id: "system-notifications",
        field: "system_notifications",
        label: "System Notifications",
        description: "Receive important system announcements and updates"
      },
      {
        id: "content-notifications",
        field: "new_content_notifications",
        label: "New Content",
        description: "Be notified when new articles are published"
      },
      {
        id: "comment-notifications",
        field: "comment_notifications",
        label: "Comments",
        description: "Be notified about replies to your comments"
      },
      {
        id: "marketing-notifications",
        field: "marketing_notifications",
        label: "Marketing",
        description: "Receive special offers and promotional updates"
      }
    ]
  }
];
